import { InjectionToken } from '@angular/core';
import { InventoryItem } from '../types/inventory-item';
import { ApiDataAccess, ResponseResult } from '@softline/core';
import {
  SOFTLINE_API_INVENTORY_ITEMS,
  SOFTLINE_API_INVENTORY_ITEMS_UPDATE,
} from '../inventory.api';

export interface InventoryItemRepository {
  load(): Promise<InventoryItem[]>;
  add(partialItem: Partial<InventoryItem>): Promise<InventoryItem>;
  remove(id: number): Promise<InventoryItem>;
  update(updatedItem: InventoryItem): Promise<InventoryItem>;
}

export const SOFTLINE_MDE_INVENTORY_ITEM_REPOSITORY =
  new InjectionToken<InventoryItemRepository>('INVENTORY_ITEM_REPOSITORY');

export class DefaultInventoryItemRepository implements InventoryItemRepository {
  constructor(protected dataAccess: ApiDataAccess) {}

  async add(partialItem: Partial<InventoryItem>): Promise<InventoryItem> {
    const response = await this.dataAccess.create<
      Partial<InventoryItem>,
      ResponseResult<InventoryItem>
    >(
      {
        path: SOFTLINE_API_INVENTORY_ITEMS,
      },
      partialItem
    );

    return response?.result ?? null;
  }

  async load(): Promise<InventoryItem[]> {
    const response = await this.dataAccess.get<ResponseResult<InventoryItem[]>>({
      path: SOFTLINE_API_INVENTORY_ITEMS,
    });

    return response?.result ?? null;
  }

  async remove(id: number): Promise<InventoryItem> {
    const response = await this.dataAccess.delete<ResponseResult<InventoryItem>>({
      path: SOFTLINE_API_INVENTORY_ITEMS_UPDATE,
      pathParams: {
        id,
      },
    });

    return response?.result;
  }

  async update(updatedItem: InventoryItem): Promise<InventoryItem> {
    const response = await this.dataAccess.update<
      InventoryItem,
      ResponseResult<InventoryItem>
    >(
      {
        path: SOFTLINE_API_INVENTORY_ITEMS_UPDATE,
        pathParams: {
          id: updatedItem.id,
        },
      },
      updatedItem
    );

    return response?.result ?? null;
  }
}
